module.exports = __webpack_public_path__ + "img/meme_04.956368b9.jpg";